import { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Box } from '@mui/material';

import PKDHeader from 'components/Home/Header';
import { StepperComponent } from 'components/OverviewFlow/StepperComponent';
import { Overview } from './Overview';
import Eligibility from './Eligibility';
import Consent from './Consent';

const steps = [
  {
    id     : 1,
    key    : 'overview',
    label  : 'Overview',
    render : (onForward) => <Overview
      onForward={onForward}
    />,
  },
  {
    id     : 2,
    key    : 'consent',
    label  : 'What am I consenting to',
    render : (onForward, onBack) => (
      <Consent
        onForward={onForward} onBack={onBack}
      />
    ),
  },
  {
    id     : 3,
    key    : 'eligibility',
    label  : 'Eligibility',
    render : (onForward, onBack) => (
      <Eligibility
        onForward={onForward} onBack={onBack}
      />
    ),
  },
];

function OverviewFlow () {
  const location = useLocation();
  const navigate = useNavigate();
  const [activeStep, setActiveStep] = useState(0);


  const forward = () => {
    if (activeStep === steps.length - 1) {
      return navigate('/create-account', {
        state : {
          from : location.pathname
        }
      });
    }
    setActiveStep(activeStep + 1);
  };
  const backward = () => setActiveStep(activeStep - 1);
  return (
    <Box>
      <PKDHeader />
      <Box>
        <StepperComponent
          steps={steps}
          activeStep={activeStep}
          hideLabel={true}
        />
      </Box>
      <Box>{steps[activeStep]?.render(forward, backward)}</Box>
    </Box>
  );
}

export default OverviewFlow;
